import React, { useEffect } from "react";
import { navigate } from "gatsby-link";
import Layout from "../components/layout";
import "../scss/global.scss";
import { FormScheme } from "../models/form-scheme";
import {
  useAuthDispatch,
  useAuthState,
  loginUser,
  stopLoading,
  startLoading,
} from "../context";
import { continueAsAnonymous } from "../context/user-context/user-actions";
import { authConfigExternal } from "../config/auth-config";
import Overlay from "../components/overlay";
import Cookies from "universal-cookie";
import { AuthService } from "../services/auth-service";
import User from "../models/user";
import { QueryStringService } from "../services/query-string-service";
import { useCookies } from "react-cookie";

type pageContext = {
  form: FormScheme;
  route: string;
};

type IProps = {
  data?: {};
  pageContext: pageContext;
  location: any;
};

export default function FormOverview({ data, pageContext, location }: IProps) {
  const formScheme = pageContext.form;
  const route = pageContext.route;
  const dispatch = useAuthDispatch();
  const { user, loading, errorMessage, isAnonymous } = useAuthState();
  const [cookies, setCookie, removeCookie] = useCookies();

  let queryString = location.search;

  useEffect(() => {
    let firstPage = formScheme.startPage;
    if (user || isAnonymous) {
      navigate(route + firstPage + queryString);
    } else if (!user && !isAnonymous && cookies.tokens) {
      startLoading(dispatch);
      const authService = new AuthService(cookies);
      authService
        .getUserInfo()
        .then((res) => {
          return loginUser(dispatch, res as User);
        })
        .then(() => {
          stopLoading(dispatch);
          navigate(route + firstPage + queryString);
        })
        .catch((err) => {
          console.log(err);
          removeCookie("tokens");
          stopLoading(dispatch);
        });
    } else {
      // console.log("guess nothing is happening");
    }
  }, [user]);

  function buildAuthUrl() {
    let paramsObject = QueryStringService.convertStringToObject(
      location.search.replace("?", "")
    );
    return (
      authConfigExternal.loginEndpoint +
      `?client_id=${authConfigExternal.clientId}` +
      `&response_type=${authConfigExternal.responseType}` +
      `&scope=${authConfigExternal.scopes.map((scope) => scope).join("+")}` +
      `&redirect_uri=${authConfigExternal.redirectUri}` +
      `&state=${encodeURIComponent(
        location.pathname +
          (paramsObject ? "?params=" + JSON.stringify(paramsObject) : "")
      )}`
    );
    // https://canterbury-cc.auth.eu-west-2.amazoncognito.com/login?client_id=3k70abfjs9cuh0dkklbro7lra7&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http://localhost:8000/login&state=%2Fforms%2Fcontact-us%3Fcategory%3Dblah%26topic%3Dblah
  }

  async function continueAsGuest(event) {
    event.preventDefault();
    try {
      let response = await continueAsAnonymous(dispatch);
      if (!response) {
        navigate("/404");
      } else {
        let firstPage = formScheme.startPage;
        navigate(route + firstPage + queryString);
      }
    } catch (err) {
      console.log(err);
    }
  }

  function expandError(event) {
    event.preventDefault();
    document.querySelector(".information-box .hidden").className = "";
  }

  // SET UP AN ARRAY TO CHECK AGAINST FOT DYNAMIC PAGES
  // COULD PERHAPS DO THIS/OR SOMETHING IN BLOCKS RENDER BASED ON THE BLOCKS BECAUSE THESE PAGES USE PARTICULAR TYPES?

  return (
    <Layout
      description=""
      metatags={[]}
      title={"form"}
      scheme={{ name: "Purple" }}
    >
      {loading ? <Overlay /> : ""}
      <div className="header">
        <h1>{formScheme.name}</h1>
        {errorMessage ? (
          <div className="information-box error">
            <h2 className="">There was an error</h2>
            <p>There seemed to be an issue with signing you in.</p>
            <p>
              <a href="" onClick={(e) => expandError(e)}>
                Details
              </a>
            </p>
            <p className="hidden">{errorMessage}</p>
          </div>
        ) : (
          ""
        )}
        <div className="signInContainer">
          <div className="halfWidth">
            <div className="contentBox">
              <h2>Sign in to your account</h2>
              <p>
                Keep a record of your cases, and save your progress so you can
                return later.
              </p>
              <a className="button button-secondary" href={buildAuthUrl()}>
                <span className="button-inner">Sign in</span>
              </a>
            </div>
          </div>
          <div className="halfWidth">
            <div className="contentBox">
              <h2>Continue without signing in</h2>
              <p>
                You'll have the option to sign up for an account when you
                complete the form.
              </p>
              <button
                className="button button-secondary"
                onClick={(e) => continueAsGuest(e)}
              >
                <span className="button-inner">Continue as a guest</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
